import { PERMISSIONS, Permission } from './constants';

export interface ParishUser {
  allowWithdrawalAccess?: boolean;
  parish?: {
    isMainParish?: boolean;
    features?: {
      allowCreateSubgroup?: boolean;
      maxSubParishes?: number;
      allowEarlyWithdrawalRequest?: boolean;
    };
  };
}

/**
 * Calcula as permissões a partir dos dados do usuário.
 * Pode ser usado fora de componentes React (ex: utilitários, testes).
 */
export function sectorCanCreateEvents(user: { parish?: { sectorAccessLevel?: string } } | null | undefined): boolean {
  return user?.parish?.sectorAccessLevel !== 'leitura';
}

export function getPermissions(user: ParishUser | null | undefined): Record<Permission, boolean> {
  if (!user?.parish) {
    return {
      [PERMISSIONS.MANAGE_SUBPARISHES]: false,
      [PERMISSIONS.REQUEST_EARLY_WITHDRAWAL]: false,
    } as Record<Permission, boolean>;
  }

  const { isMainParish, features } = user.parish;

  return {
    [PERMISSIONS.MANAGE_SUBPARISHES]: !!(
      isMainParish &&
      (features?.allowCreateSubgroup || (features?.maxSubParishes ?? 0) > 0)
    ),
    [PERMISSIONS.REQUEST_EARLY_WITHDRAWAL]: !!(
      isMainParish &&
      user.allowWithdrawalAccess !== false &&
      features?.allowEarlyWithdrawalRequest
    ),
  } as Record<Permission, boolean>;
}
